import { TruncatableText } from "@Calibrations/components/TruncatableText/TruncatableText"
import * as React from "react"

export const PrimitiveCell = ({ value }: { value: string | null }) => {
  return value ? <TruncatableText>{value}</TruncatableText> : <>-</>
}
